export default "__VITE_ASSET__CgtWd9tO__"